import { render, staticRenderFns } from "./stockLayout.vue?vue&type=template&id=7f36f8b7&scoped=true&"
import script from "./stockLayout.vue?vue&type=script&lang=js&"
export * from "./stockLayout.vue?vue&type=script&lang=js&"
import style0 from "./stockLayout.vue?vue&type=style&index=0&id=7f36f8b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36f8b7",
  null
  
)

export default component.exports